module.exports = (__webpack_require__(65))("./node_modules/styled-components/dist/styled-components.browser.esm.js");